import React from 'react';
import CapexCaptureWidgetBuilder from './CapexCaptureWidgetBuilder';
import CapexCaptureWidgetRenderer from './CapexCaptureWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { CapexCaptureWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIndustry } from '@fortawesome/free-solid-svg-icons';

export { default as CapexCaptureWidgetBuilder } from './CapexCaptureWidgetBuilder';
export { default as CapexCaptureWidgetRenderer } from './CapexCaptureWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'capex_capture',
  meta: {
    label: 'Revenue vs Capex',
    icon: React.createElement(FontAwesomeIcon, { icon: faIndustry }),
    description: 'Asset revenue vs. summed hyperscaler capex (MSFT + GOOGL + AMZN + META) with a % capture line',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'CAPEX_CAPTURE',
    params: [
      { key: 'period', label: 'Period', defaultValue: 'annual', type: 'select', options: [{ value: 'annual', label: 'Annual' }] },
    ],
  },
  defaultSize: { w: 12, h: 8, minW: 6, minH: 5 },
  defaultConfig: () => ({} as CapexCaptureWidgetConfig),
  Builder: CapexCaptureWidgetBuilder,
  Renderer: CapexCaptureWidgetRenderer,
  Preview,
};
